import api from "./api";

export const getUnitConsumerAll = async () => {
    const response = await api.get(`unitConsumer/listAll`);
    return response.data;
};

export const getUnitConsumerAllFilter = async (concessionarie?: string | null, plant?: string | null) => {
    const response = await api.get(`unitConsumer/listAll?concessionarie=${concessionarie ? concessionarie : ""}&plant=${plant ? plant : ""}`);
    return response.data;
};

export const getUnitConsumerAllFilterPagination = async (concessionarie?: string | null, plant?: string | null, name?: string, isIncludedComposite?: boolean, limit?: number, page?: number) => {
    const response = await api.get(`unitConsumer/listAllPagination?concessionarie=${concessionarie ? concessionarie : ""}&plant=${plant ? plant : ""}${name ? `&name=${name}` : ""}&isIncludedComposite=${isIncludedComposite ? isIncludedComposite : ""}&limit=${limit ? limit : ""}&page=${page ? page : ""}`);
    return response.data;
};

export const postUnitConsumerAll = async (body: any) => {
    const response = await api.post(`unitConsumer/`, body);
    return response.data;
};

export const updateUnitConsumerAll = async (body: any, id: string) => {
    const response = await api.put(`unitConsumer/${id}`, body);
    return response.data;
};


export const getUnitConsumerOne = async (id: string) => {
    const response = await api.get(`unitConsumer/${id}`);
    return response.data;
};

export type UnitConsumerVerificationCode = {
    code: string | null;
    brand?: string | null;
    receivedAt?: string;
    idUnitConsumer?: string;
    unitConsumerName?: string | null;
};

export const getUnitConsumerVerificationCode = async (id: string): Promise<UnitConsumerVerificationCode> => {
    const response = await api.get(`unitConsumer/${id}/verificationCode`);
    return response.data;
};

export const getPendingVerificationCodes = async (): Promise<UnitConsumerVerificationCode[]> => {
    const response = await api.get(`unitConsumer/verificationCodes/pending`);
    return response.data;
};

export const deleteUnitConsumerAll = async (id: string) => {
    const response = await api.delete(`unitConsumer/${id}`);
    return response.data;
};